'use strict';

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  ProductNotAvailable
// -----------------------------------------------------------
const ProductNotAvailable = ({visible}) => {
  if (!visible)
    return null;

  return <div className="product-not-available p-3">
           <strong>This item is not available</strong> with these options.
           <br />
           Please choose different options to purchase this product.
         </div>;
};

export default ProductNotAvailable;
